import React from 'react';
import Routing from './config/Route';

function App() {
  return (
    <>
      <Routing />
      
    </>
  );
}

export default App;
